import React, { memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTranslation } from "react-i18next";

import { Form, Input, Col } from 'antd';

function PhoneField({
  data,
  index,
  // default
  className
}) {
  const childClassNames = classNames('custom-form-column', 'phone-input-column', className);
  const { t } = useTranslation();

  const validateMobileNumber = useCallback((rule, value, callback) => {
    if (value && value?.length > 0 && value?.length < 7) {
      return Promise.reject(t("inputs.minimumCharacters", { min: 7 }));
    } else {
      return Promise.resolve();
    }
  }, []);

  return data && (
    <Col
      key={data?.name + index + '-col'}
      md={data?.col || 24}
      xs={24}
      offset={data?.offset || null}
      className={childClassNames}
    >
      <Form.Item
        key={data?.name + index + '-item'}
        label={data?.displayLabel ? data?.label : data?.label}
        name={data?.name}
        className={data?.name + '-wrapper'}
        initialValue={data?.value}
        rules={[
          {
            required: data?.required || false,
            message: t("inputs.mandatoryField"),
            validateTrigger: 'onSubmit',
          },
          {
            pattern: '^([+]?[-]?[1-9\b]?[-. ]?[0-9\b]*|0)+$',
            message: t("inputs.mandatoryPhoneNumber"),
            validateTrigger: 'onSubmit',
          },
          {
            validator: validateMobileNumber,
            validateTrigger: 'onSubmit',
          },
        ]}
      >
        <Input
          placeholder={
            data?.placeholder !== undefined
              ? data?.placeholder
              : data?.label
          }
        />
      </Form.Item>
    </Col>
  );
};

PhoneField.defaultProps = {
  index: 1,
};

PhoneField.propTypes = {
  data: PropTypes.oneOfType([
    PropTypes.bool.isRequired,
    PropTypes.object.isRequired,
  ]),
};

export default memo(PhoneField);